import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { AuthService, CacheService, SettingsService, WindowService } from '@gallaghercp/core-frontend';
import { Observable, of, Subscription } from 'rxjs';
import { ClientService } from '../../services/client.service';

@Component({
    selector: 'core-notifications',
    templateUrl: './notifications.component.html',
    standalone: false,
})
export class NotificationsComponent implements OnInit, OnDestroy {
    protected auth = inject(AuthService);
    protected client = inject(ClientService);
    protected http = inject(HttpClient);
    protected cache = inject(CacheService);
    protected settings = inject(SettingsService);
    protected windowService = inject(WindowService);

    @ViewChild('notification') notification: any;

    notifications$?: Observable<any>;
    notificationsSubscription?: Subscription;

    loadingNotifications: boolean = true;
    showNotifications?: boolean;
    seenNotifications?: boolean;
    isLoggedIn?: boolean;
    heroImagesEnabled?: boolean;

    subscriptions: Subscription[] = [];

    ngOnInit(): void {
        this.isLoggedIn = this.auth.isAuthenticated();
        this.loadNotifications(true);

        this.subscriptions.push(
            this.settings.showHeroImages().subscribe((state: any) => {
                this.heroImagesEnabled = state;
            }),
        );
    }

    loadNotifications(clear?: boolean) {
        this.loadingNotifications = true;
        if (this.auth.isAuthenticated()) {
            this.notificationsSubscription = this.client
                .getUserNotifications(clear)
                .subscribe((notifications: any[]) => {
                    this.notifications$ = of(notifications);

                    notifications.forEach(notification => {
                        if (notification.priority === 'HIGH' && !this.showNotifications && !this.seenNotifications) {
                            setTimeout(() => {
                                this.showNotifications = true;
                                this.seenNotifications = true;
                            }, 2000);
                        }
                    });
                    this.loadingNotifications = false;
                });
        }
    }

    clearNotification(notification: any): Subscription {
        notification.loading = true;
        return this.http.post('user-notification-interact', { notification: notification.id }).subscribe(() => {
            setTimeout(() => {
                notification.loading = false;
            }, 2000);
            return this.loadNotifications(true);
        });
    }

    clearAllNotifications(): Subscription {
        this.loadingNotifications = true;
        return this.http.post('user-notification-interact', {}).subscribe(() => {
            setTimeout(() => {
                this.loadingNotifications = false;
            }, 2000);
            this.notifications$ = of([]);
            return this.loadNotifications(true);
        });
    }

    goToNotificationLink($event: Event, notification: any) {
        if (notification.data.link.indexOf('/api/') > -1 || notification.data.link.indexOf('http') > -1) {
            return true;
        }
        $event.preventDefault();
        return this.windowService.redirect(notification.data.link.replace('/#', ''));
    }

    trackByFn(idx: number, item: any) {
        return item.id + '_' + idx;
    }

    ngOnDestroy(): void {
        if (this.notificationsSubscription) {
            this.notificationsSubscription.unsubscribe();
        }
    }

    onNotificationBellClick() {
        this.showNotifications = !this.showNotifications;
    }
}
